import { publicPaths } from './constants'

export const pxToRem = (px: number) => `${px / 16}rem`

export const checkForPublicPath = (path: string) => publicPaths.includes(path)
